import { useEffect } from "react";

const abs = (url) => {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  return `${window.location.origin}${url}`;
};

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, image, path, type = "website", jsonLd, noindex } = {}) => {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "Pantheon Art");
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    if (image) {
      setMeta("property", "og:image", abs(image));
      setMeta("name", "twitter:image", abs(image));
    }
    if (path) {
      setMeta("property", "og:url", abs(path));
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", abs(path));
    }
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.title = "Pantheon Art";
      if (script) script.remove();
    };
  }, [title, description, image, path, type, noindex, JSON.stringify(jsonLd)]);
};

export const stripHtml = (html) =>
  (html || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
